(() => {
  const reorderHash = '#nachbestellen';

  document.documentElement.dataset.zfoldAnchor = 'ready';

  const jumpToReorder = () => {
    if (window.location.hash !== reorderHash) return;

    const target = document.getElementById('nachbestellen');
    if (!target) return;

    const header = document.querySelector('header-component, header');
    const headerHeight = header?.getBoundingClientRect().height || 0;
    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;

    window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
  };

  const scheduleJump = () => {
    window.requestAnimationFrame(() => window.requestAnimationFrame(jumpToReorder));
  };

  if ('scrollRestoration' in window.history && window.location.hash === reorderHash) {
    window.history.scrollRestoration = 'manual';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleJump, { once: true });
  } else {
    scheduleJump();
  }

  window.addEventListener('load', scheduleJump, { once: true });
  window.addEventListener('pageshow', scheduleJump, { once: true });
  [100, 300, 700, 1200, 2000].forEach((delay) => {
    window.setTimeout(jumpToReorder, delay);
  });
})();
